<template>
  <tr>
    <td data-label="Name">
      <strong>
        {{ video.name }}
      </strong>
    </td>
    <td data-label="URL">
      <a :href="video.url" target="_blank">
        {{ video.url }}
      </a>
    </td>
    <td class="button-3 text-center">
      <button class="my-2 btn btn-warning" @click="editVideo()">
        <i class="fa fa-edit" /> Edit
      </button>
      <button class="my-2 btn btn-danger" @click="deleteVideo()">
        <i class="fa fa-trash" /> Delete
      </button>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'VideoRow',
  props: {
    object: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: {
    video () {
      return {
        ...this.object
      }
    }
  },
  methods: {
    editVideo () {
      this.$emit('edit', { permalink: 'editVideo', uuid: this.video.uuid })
    },
    deleteVideo () {
      this.$emit('deleteObject', { permalink: 'deleteVideo', uuid: this.video.uuid })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/Video.vue